import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import Delete from "rialto-icons/Delete";

import { $grayLight, $white } from "../../_variables";

import { initials } from "./avatarUtils.js";

import styles from "./Avatar.css";

const Avatar = ({ backgroundColor, color, fname, isCurrentUser, isDeleted, lname, size, src }) => (
  <div
    className={cx(styles.wrapper, {
      [styles[size]]: !!size,
      [styles.currentUser]: isCurrentUser,
    })}
  >
    <>
      {!isDeleted && (
        <div className={styles.placeholder} style={{ backgroundColor, color }}>
          {initials(fname, lname)}
        </div>
      )}
      {!isDeleted && src && (
        <div className={styles.picture} style={{ backgroundImage: `url(${src})` }} />
      )}
      {isDeleted && (
        <div className={styles.icon}>
          <Delete />
        </div>
      )}
    </>
  </div>
);

Avatar.propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  src: PropTypes.string,
  size: PropTypes.string,
  fname: PropTypes.string,
  lname: PropTypes.string,
  isCurrentUser: PropTypes.bool,
  isDeleted: PropTypes.bool,
};

Avatar.defaultProps = {
  backgroundColor: $grayLight,
  color: $white,
};

export default Avatar;
